function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { NjcModal as h } from "../modal.js";
import "../../card/gator/base/card.gator.js";
import "../../card/gator/header/card-header.gator.js";
import "../../card/gator/content/card-content.gator.js";
import "../../card/gator/footer/card-footer.gator.js";
import "../../button/slds/button.slds.js";
import "../../button/gator/button.gator.js";
import "../../icon-button/gator/icon-button.gator.js";
import "../../input/gator/input-currency/input-currency.gator.js";
import "../../input/gator/input-date/input-date.gator.js";
import "../../input/gator/input-label/input-label.gator.js";
import "../../input/gator/help-text/help-text.gator.js";
import "../../input/gator/input-text/input-text.gator.js";
import "../../input/gator/input-textarea/input-textarea.gator.js";
import "../../input/gator/input-masked/input-masked.gator.js";
import "../../input/gator/input-percent/input-percent.gator.js";
import "../../input/gator/input-phone/input-phone.gator.js";
import "../../input/gator/dropdown/input-dropdown.gator.js";
import "../../input/gator/input-file/input-file.gator.js";
import "../../input/gator/input-file/file-uploaded-preview/file-upload-preview.gator.js";
import "../../input/gator/input-search/input-search.gator.js";
import "../../input/gator/input-time/input-time.gator.js";
import "../../text-detail/gator/text-detail.gator.js";
import "../../skeleton-loader/gator/skeleton-loader.gator.js";
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as a } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as p } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { KEY_CONSTANTS as d } from "../../../consts/key-constants.js";
import g from "../../../packages/web-components/src/components/modal/gator/modal.gator.scss.js";
import f from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import b from "../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import { createRef as u, ref as m } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { getFirstFocusableElement as v } from "../../../utils/accessibility-utils.js";
import { unsafeCSS as n } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var k = Object.getOwnPropertyDescriptor,
  y = function y(t, e, o, r) {
    for (var i = r > 1 ? void 0 : r ? k(e, o) : e, s = t.length - 1, c; s >= 0; s--) (c = t[s]) && (i = c(i) || i);
    return i;
  };
var l = /*#__PURE__*/function (_h) {
  function l() {
    var _this;
    _classCallCheck(this, l);
    _this = _callSuper(this, l, arguments), _this._destructiveMessageRef = u(), _this._primaryActionButtonRef = u();
    return _this;
  }
  _inherits(l, _h);
  return _createClass(l, [{
    key: "render",
    value: function render() {
      return this.open ? a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div\n                class=\"gator-modal-background\"\n                @click=", "\n            ></div>\n\n            <ngc-card\n              role=\"", "\"\n              aria-modal=\"true\"\n              aria-labelledby=\"gator-modal-title\"\n              class=\"gator-modal gator-modal--", "\"\n              elevated\n            >\n                <div class=\"gator-modal-wrapper\">\n                    <div class=\"gator-modal-header\">\n                        <ngc-card-header>\n                            <ngc-text-detail\n                                id=\"gator-modal-title\"\n                                title=\"", "\"\n                                subtitle=\"", "\"\n                                invert-title\n                                size=\"large\"\n                                ?skeleton=\"", "\"\n                            >\n                                <ngc-icon-button\n                                    slot=\"append\"\n                                    class=\"gator-modal-close-button\"\n                                    title=\"Close\"\n                                    icon-name=\"exit\"\n                                    size=\"medium\"\n                                    .ariaLabel=\"Close ", " modal\"\n                                    @click=", "\n                                    @keydown=", "\n                                ></ngc-icon-button>\n                            </ngc-text-detail>\n                        </ngc-card-header>\n                    </div>\n\n                    <div class=\"gator-modal-content\">\n                        ", "\n                    </div>\n\n                    ", "\n                </div>\n            </ngc-card>\n        "])), this.handleCloseClick, this.dialogRole, this.size, this.title, this.subtitle, this.skeleton, this.title, this.handleCloseClick, this.handleCloseKeydown, this.skeleton ? this.gatorModalContentLoadingMarkup : a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<slot></slot>"]))), this.gatorModalFooterMarkup) : null;
    }
  }, {
    key: "gatorModalContentLoadingMarkup",
    get: function get() {
      return a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            <ngc-skeleton-loader full-width height=\"16\" radius=\"100\"></ngc-skeleton-loader>\n            <ngc-skeleton-loader full-width height=\"18\" radius=\"100\"></ngc-skeleton-loader>\n        "])));
    }
  }, {
    key: "gatorModalFooterMarkup",
    get: function get() {
      return ["decide", "destructive", "confirmation"].includes(this.variant) ? a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            <div class=\"gator-modal-footer\">\n                <slot name=\"footer\">\n                    ", "\n\n                    <div class=\"gator-modal-action-buttons\">\n                        ", "\n                        ", "\n                    </div>\n                </slot>\n            </div>\n        "])), this.footerWarningMessageMarkup, this.footerSecondaryActionButtonMarkup, this.footerPrimaryActionButtonMarkup) : null;
    }
  }, {
    key: "footerWarningMessageMarkup",
    get: function get() {
      var _this2 = this;
      return !["destructive"].includes(this.variant) || this.skeleton || !this.destructiveMessageText ? null : (requestAnimationFrame(function () {
        var e = v(_this2._primaryActionButtonRef.value);
        _this2._destructiveMessageRef.value && e && (e.ariaDescribedByElements = [_this2._destructiveMessageRef.value]);
      }), a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            <div class=\"gator-modal-warning\">\n                <ngc-icon name=\"warning\"></ngc-icon>\n                <ngc-input-label ", ">\n                    ", "\n                </ngc-input-label>\n            </div>\n        "])), m(this._destructiveMessageRef), this.destructiveMessageText));
    }
  }, {
    key: "footerPrimaryActionButtonMarkup",
    get: function get() {
      return ["decide", "destructive", "confirmation"].includes(this.variant) ? a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            <ngc-button\n                ", "\n                class=\"gator-modal-primary-button\"\n                variant=\"", "\"\n                size=\"", "\"\n                @click=", "\n                ?skeleton=\"", "\"\n            >\n                ", "\n            </ngc-button>\n        "])), m(this._primaryActionButtonRef), this.variant === "destructive" ? "destructive" : "primary", this.buttonSize, this.handlePrimaryActionClick, this.skeleton, this.primaryActionText) : null;
    }
  }, {
    key: "footerSecondaryActionButtonMarkup",
    get: function get() {
      return ["decide", "destructive"].includes(this.variant) ? a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            <ngc-button\n                class=\"gator-modal-secondary-button\"\n                variant=\"secondary\"\n                size=\"", "\"\n                @click=", "\n                ?skeleton=\"", "\"\n            >\n                Cancel\n            </ngc-button>\n        "])), this.buttonSize, this.handleSecondaryActionClick, this.skeleton) : null;
    }
  }, {
    key: "buttonSize",
    get: function get() {
      switch (this.size) {
        case "small":
          return "xlarge";
        case "standard":
          return "medium";
        case "fullscreen":
          return "large";
        default:
          return "medium";
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(t) {
      if (t.key === d.ESCAPE && this.handleCloseClick(t), t.key === d.TAB) {
        var _this$shadowRoot;
        var e = this.getKeyboardFocusableElements(),
          o = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.activeElement,
          r = e[0],
          i = e[e.length - 1];
        t.shiftKey ? o === r && (t.preventDefault(), i.focus()) : o === i && (t.preventDefault(), r.focus());
      }
    }
  }, {
    key: "handleCloseClick",
    value: function handleCloseClick(t) {
      t.preventDefault(), t.stopImmediatePropagation(), this.dispatchEvent(new CustomEvent("close", {
        bubbles: !0
      }));
    }
  }, {
    key: "handleCloseKeydown",
    value: function handleCloseKeydown(t) {
      (t.code === "Enter" || t.code === "Space") && this.handleCloseClick(t);
    }
  }, {
    key: "handlePrimaryActionClick",
    value: function handlePrimaryActionClick(t) {
      t.preventDefault(), t.stopImmediatePropagation(), this.dispatchEvent(new CustomEvent("primary-action-click", {
        bubbles: !0
      }));
    }
  }, {
    key: "handleSecondaryActionClick",
    value: function handleSecondaryActionClick(t) {
      t.preventDefault(), t.stopImmediatePropagation(), this.dispatchEvent(new CustomEvent("secondary-action-click", {
        bubbles: !0
      }));
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(l, "connectedCallback", this, 3)([]), this.addEventListener("keydown", this.handleKeyDown), this.focusFirstElement();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener("keydown", this.handleKeyDown), _superPropGet(l, "disconnectedCallback", this, 3)([]);
    }
  }, {
    key: "updated",
    value: function updated(t) {
      _superPropGet(l, "updated", this, 3)([t]), t.has("open") && this.open && this.focusFirstElement();
    }
  }, {
    key: "getKeyboardFocusableElements",
    value: function getKeyboardFocusableElements() {
      var _this$shadowRoot2;
      var t = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.querySelectorAll('a[href],button,ngc-button,ngc-icon-button,input,textarea,select,details,[tabindex]:not([tabindex="-1"])');
      return Array.from(t !== null && t !== void 0 ? t : []).filter(function (o) {
        return !o.hasAttribute("disabled") && !o.hasAttribute("aria-hidden");
      });
    }
  }, {
    key: "focusFirstElement",
    value: function focusFirstElement() {
      if (!this.open) return;
      var t = this.getKeyboardFocusableElements();
      if (t.length > 0) {
        var e = t[0];
        requestAnimationFrame(function () {
          e.focus();
        });
      }
    }
  }]);
}(h);
l.styles = [n(g), n(f), n(b)];
l = y([p("ngc-modal")], l);
export { l as NgcModal };